import React, { useState } from "react";
import "../CheckIn.css";

function CheckIn() {
  const [email, setEmail] = useState("");
  const [activity, setActivity] = useState("");
  const [message, setMessage] = useState("");
  const [showRegisterButton, setShowRegisterButton] = useState(false);

  const handleCheckIn = async () => {
    setMessage("");
    setShowRegisterButton(false);

    const res = await fetch("/api/checkin", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, activity })
    });

    const data = await res.json();

   /* if (res.status === 403 && data.askToRegister) {
      setMessage(
        "Sorry, we couldn't find your registration for this activity, but don't worry — you can register now."
      );
      setShowRegisterButton(true);
      return;
    }*/
if (res.status === 403 && data.askToRegister) {
  window.location.href = "/notregistered";
  return;
}

    if (!res.ok) {
      setMessage(data.message || "Something went wrong.");
      return;
    }
window.location.href = "/successful";

   // setMessage(data.message);
  };

  return (
    <div className="checkin-wrapper">
      
      {/* Header Image (same as Register page) */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img
          src="/images/FITZONE.png"
          alt="FITZONE Logo"
          className="responsive-image"
          style={{ borderRadius: "8px" }}
        />
      </div>

      <h1 style={{ textAlign: "center" }}>FITZONE Check‑In</h1>

      <form className="checkin-form" onSubmit={(e) => e.preventDefault()}>
        <label>Email:</label>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label>Activity:</label>
        <select value={activity} onChange={(e) => setActivity(e.target.value)}>
          <option value="">Select activity</option>
          <option value="FITZONE">FITZONE (Beginners class - Tuesday/Thursday at 6:30 pm)</option>
          <option value="FITZONE+">FITZONE+ (High Intensity class - Monday/Wednesday at 6:00 pm)</option>
          <option value="FITZONE SPIN">FITZONE+ SPIN (Intermediate - Monday/ Wednesday at 7:00 am)</option>
          <option value="FITZONE-V">FITZONE-V (Virtual Classes at your own pace)</option>
          <option value="FITZONE RUN CLUB">FITZONE RUN CLUB (Saturdays at 7:00 am)</option>
        </select>

        <button className="checkin-btn" onClick={handleCheckIn}>
          Check‑In
        </button>

        {message && <p className="checkin-message">{message}</p>}

        {showRegisterButton && (
          <button
            className="register-now-btn"
            onClick={() => (window.location.href = "/")}
          >
            Register Now
          </button>
        )}
      </form>
    </div>
  );
}

export default CheckIn;
